import React, {Component} from 'react';
import { Link } from 'react-router-dom'
import './NavbarDrawerDropdown.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

export default class NavbarDrawerDropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			listOpen: false,
		};
	}

	toggleList(){
		this.setState(prevState => ({
		listOpen: !prevState.listOpen
		}));
	}

/* arrow dunctions () => this..togglisit()
The problem with this syntax is that a different callback is created each time the LoggingButton renders.
In most cases, this is fine. However, if this callback is passed as a prop to lower
components, those components might do an extra re-rendering.
We generally recommend binding in the constructor or using the class fields syntax,
to avoid this sort of performance problem.*/

  componentDidMount() {  }
  componentWillUnmount() {  }

	render() {
  		const {listOpen} = this.state
		return (
			<React.Fragment>
				<div className="navbar_drawer_header" onClick={() => this.toggleList()}>
					<div className="navbar_drawer_header_title">{this.props.headerTitle}</div>
					<div className="spacer"/>
					{listOpen ? <FontAwesomeIcon icon={faCaretUp} size="lg"/> : <FontAwesomeIcon icon={faCaretDown} size="lg"/>}
				</div>
				<hr className="navbar_dropdown_hr"/>
				{listOpen && <ul className="dropdown_list">
					{this.props.data.map(item => (
						<Link to={item.childLink} onClick={this.props.click} key={item.childLink} >
							<li className="dropdown_list_item" key={item}>
								{item.childTitle}
							</li>
							<hr className="navbar_dropdown_hr"/>
						</Link>
					))}
				</ul>}
			</React.Fragment>
		)
	}
};
